// extracted by mini-css-extract-plugin
export default {"description":"ForgottenPasswordSetNewPasswordFailed_description__AjTq9","button":"ForgottenPasswordSetNewPasswordFailed_button__FHWf7"};